import { render, staticRenderFns } from "./PowerupHierarchyGraph.vue?vue&type=template&id=0f9c8a29"
import script from "./PowerupHierarchyGraph.vue?vue&type=script&lang=js"
export * from "./PowerupHierarchyGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports